import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from '../router';
axios.defaults.withCredentials = true;
Vue.use (VueAxios, axios);

let baseurl = process.env.NODE_ENV === 'production'
  ? 'https://sales.api.tkplusemi.com/'
  : '/back';
function getCookie (name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    let cookies = document.cookie.split (';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim ();
      // 判断这个cookie的参数名是不是我们想要的
      if (cookie.substring (0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent (cookie.substring (name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}
let cookie = getCookie ('fileCookie');
const url = window.location.href;
if (!cookie) {
  window.location.href = 'https://login.tkplusemi.com?url=' + url;
}
let imageUrl = process.env.NODE_ENV === 'production'
  ? 'https://sales.api.tkplusemi.com/'
  : 'http://jh.tkplusemi.com:9010/';

export let imgUrl = imageUrl;
export const upload_url = process.env.NODE_ENV === 'production'
  ? 'https://sales.api.tkplusemi.com/public/upload'
  : 'http://jh.tkplusemi.com:9010/public/upload';
let billBaseurl = process.env.NODE_ENV === 'production'
  ? 'https://erp-report.tkplusemi.com/'
  : '/back';
export let apiCollectionbill = Vue.axios.create ({
  method: 'GET',
  baseURL: billBaseurl,
});

export let apiResourcebill = Vue.axios.create ({
  method: 'POST',
  baseURL: billBaseurl,
});

export let apiCollection = Vue.axios.create ({
  method: 'GET',
  baseURL: baseurl,
});

export let apiResource = Vue.axios.create ({
  method: 'POST',
  baseURL: baseurl,
});
export let apiFormSubmit = Vue.axios.create ({
  method: 'POST',
  baseURL: baseurl,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
export let apiPut = Vue.axios.create ({
  method: 'PUT',
  baseURL: baseurl,
});
export let apiDelete = Vue.axios.create ({
  method: 'DELETE',
  baseURL: baseurl,
});
const axiosInstace = [
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut,
  apiCollectionbill,
  apiResourcebill,
];
axiosInstace.forEach (item => {
  item.defaults.withCredentials = true;
  item.defaults.headers['x-token'] = cookie;
  item.interceptors.response.use (
    response => {
      if (response.data.data.reload) {
        // router.replace ('/login');
      } else {
        return response;
      }
    },
    error => {
      if (error && error.response) {
        router.push ('/error');
      }
    }
  );
});



// WEBPACK FOOTER //
// ./src/api/index.js